import registerServiceWorker from './registerServiceWorker'
// import init scripts
import './utils/init'
import Hotjar from '@hotjar/browser'
import { setupSentry } from './sentry'
import { registerApplication, start } from 'single-spa'

const siteId = 2917464
const hotjarVersion = 6

Hotjar.init(siteId, hotjarVersion)
setupSentry()

// Reference Example: https://github.com/alocke12992/migrating-to-single-spa-react/tree/master
registerApplication(
  'root',
  () => import('./root.app.js'),
  () => true,
)

start()
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js